var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCronos = function SvgCronos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.796,
    cy: 12.534,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.296 4.534 7 4v8l-7 4-7-4v-8l7-4Zm-3.245 7.064-1.755 1.298 2.392 4.138h.955l1.13-1.047v-.526L11.6 14.343V12.58l-1.55-.98Zm6.496-.012-1.532.993v1.764l-1.172 1.118v.526l1.13 1.035h.943l2.38-4.126-1.749-1.31Zm-1.55-.496h-3.39l.571 1.483-.174 1.662h1.292l1.304-.006-.162-1.656.559-1.483Zm.907-3.056H10.67l-.607 2.655h6.472l-.63-2.655Z",
    fill: "#000"
  })));
};

export default SvgCronos;